export default "__VITE_ASSET__BFE6F4yP__"